export default __webpack_public_path__ + "static/media/MarkerRaider.0ffb006c.svg";